/* eslint-disable */

/**
 * This file includes polyfills loaded before the app.
 *
 * The app targets evergreen browsers (see the Browserslist config) and builds
 * with AOT, so no ECMAScript or `Reflect` polyfills are required. Zone.js was
 * removed when the app moved to zoneless change detection; HammerJS was
 * replaced by the native pointer-event gesture directives in
 * `app/shared/directives/gestures.directive.ts`.
 */

// resolves node globals error (https://github.com/angular/angular-cli/issues/9827#issuecomment-386154063)
(window as any).global = window;
